import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { node, number, oneOfType, string } from 'prop-types';
import Text from '../Text';

const ItemDescription = _ref => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
    "data-testid": "item-description"
  }), children);
};

process.env.NODE_ENV !== "production" ? ItemDescription.propTypes = {
  children: node,
  fontSize: oneOfType([string, number]),
  fontWeight: string
} : void 0;
ItemDescription.defaultProps = {
  color: 'inherit',
  fontWeight: 'normal',
  display: 'block',
  as: 'small',
  fontSize: 0,
  mt: 1
};
ItemDescription.displayName = 'ItemDescription';
export default ItemDescription;